/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Patch, PatchOperation } from './data-rest.model';

export function mapToPatch(toPatch: unknown, prefix: string = ''): Patch[] {
  return Object.entries(toPatch).reduce<Patch[]>((acc, [key, value]) => {
    const path: string = prefix ? `${prefix}/${key}` : key;

    if (typeof value === 'object' && !Array.isArray(value)) {
      return acc.concat(mapToPatch(value, path));
    }

    return acc.concat([buildPatch(path, value)]);
  }, []);
}

export function buildPatch(key: string, value: unknown): Patch {
  return {
    op: PatchOperation.REPLACE,
    path: `/${key}`,
    value: value,
  };
}
